<ng-container *ngIf="product">
  <div *ngIf="isAddedInWishList && wishListEntries; else addItem">
    <button
      class="btn btn-link button-remove heart-icon"
      (click)="removeEntry(product)"
      [cxAtMessage]="'addToWishList.removedFromWishList' | cxTranslate"
    >
      <cx-icon [type]="iconTypes.HEART"></cx-icon>
    </button>
  </div>
  <ng-template #addItem>
    <button
      class="btn btn-link button-add heart-icon"
      (click)="addEntry(product)"
      [cxAtMessage]="'addToWishList.addedToWishList' | cxTranslate"
    >
      <cx-icon [type]="iconTypes.EMPTY_HEART"></cx-icon>
    </button>
  </ng-template>
</ng-container>
